/**
 * @generated SignedSource<<3d6430e28fd87ffc1698e0a2b78abee5>>
 * @relayHash fb19b06a73ba54a668887e69c1f4794a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4706606b7a1bbd30603ffce7a44a27addfc894bf108b137ff413f3dbdbfa145f

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery$variables = {
  cloudId: string;
  first?: number | null | undefined;
};
export type starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery$data = {
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"starredFiltersList_navigationAppsSidebarCommon">;
  };
};
export type starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery = {
  response: starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery$data;
  variables: starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v1/*: any*/),
              "kind": "FragmentSpread",
              "name": "starredFiltersList_navigationAppsSidebarCommon"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraFilterConnection",
            "kind": "LinkedField",
            "name": "favouriteFilters",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraFilterEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "filterId"
                      },
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isJiraFilter"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isFavourite"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "jql"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "isEditable"
                          }
                        ],
                        "type": "JiraCustomFilter"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4706606b7a1bbd30603ffce7a44a27addfc894bf108b137ff413f3dbdbfa145f",
    "metadata": {},
    "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "da050f6d21f5e8832ac98a838f9ea1ab";

export default node;
